export default __webpack_public_path__ + "static/media/verify-error.c2bc0945.png";